import { images } from "../../Constants/imageslinks";

function NewportSection() {
  return (
    <div className="bg-[linear-gradient(to_right,#151E1D_0%,#0B1111_99%,#0B1111_100%)]">
      <div className="3xl:container 3xl:mx-auto lg:px-[11.66vw] 3xl:px-[224px] md:pl-8 pl-4 flex justify-between items-center overflow-hidden">
        <div className="sm:max-w-[440px] max-w-[180px] flex flex-col gap-4 -mr-5 z-10">
          <p className="font-light md:text-base text-[13px] sm:leading-6 leading-[19px] text-primary100">
            “It’s easy to be seduced by the latest app or service, but then
            forget its cost in terms of the most important resource we possess:
            the minutes of our life.”
          </p>
          <p className="font-light sm:text-sm text-[13px] sm:leading-6 leading-[19px] text-primary100/50">
            - Cal Newport, Digital Minimalism
          </p>
        </div>

        <img
          src={images.newsportImageMobile}
          alt="image"
          className="w-[80%] max-w-[400px] min-w-[215px] min-h-[200px] h-auto z-0 md:block hidden"
        />
        <img
          src={images.newsportImageMobile}
          alt="image"
          className="w-[40%] max-w-[451px] min-w-[215px] min-h-[230px] h-auto z-0 block md:hidden"
        />
      </div>
    </div>
  );
}

export default NewportSection;
